import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Snackbar,
  TextField,
  withStyles
} from "@material-ui/core";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from "@material-ui/lab";
import Swal from "sweetalert2";
import Paper from "@material-ui/core/Paper";
import MUIDataTable from "mui-datatables";

class ImportBookkeeping extends Component {

  constructor(props) {
    super(props);
    this.state = {
      import_text: "",
      pay_day_date: null,
      dataIsParsed: false,
      parsedData: null,
      isSaving: false,
      apiError: false,
      errorMsg: "",
      parseError: false,
      formError: false,
    };
  }

  render() {
    const alerts = (<>
      {this.state.parseError === true && (
        <Alert className="error" severity="error">
          Unable to parse pasted text. Please copy and paste the necessary
          section of the document.
        </Alert>
      )}
      {this.state.apiError === true && (
        <Alert className="error" severity="error">
          {this.state.errorMsg}
        </Alert>
      )}
      {this.state.formError === true && (
        <Alert className="error" severity="error">
          Please fill out all fields.
        </Alert>
      )}
    </>);

    return (<>
      <br/>
      {alerts}
      <Paper
        elevation={5}
        style={{
          padding: "2%",
          marginLeft: "5%",
          marginRight: "5%",
          marginBottom: "1%",
        }}
      >
        <Form>
          <Row>
            <Col>
              <Form.Label>Pay Day</Form.Label>
              <Form.Control
                type="date"
                name="pay_day_date"
                disabled={this.state.isSaving}
                value={this.state.pay_day_date}
                onChange={(event) => this.handleChange(event, "pay_day_date")}
              />
              <Button
                variant="primary"
                disabled={this.state.isSaving}
                onClick={(event) => this.parseBookkeeping(event)}
              >
                Preview Bookkeeping
              </Button>
            </Col>
            <Col xs={10}>
              <FormLabel component="legend" style={{ color: "black" }}>
                 Bookkeeping Contents
              </FormLabel>
              <TextField
                style={{
                  backgroundColor: "white",
                  margin: "5px",
                  width: "100%",
                }}
                multiline
                minRows={4}
                maxRows={this.state.dataIsParsed ? 4 : 8}
                variant="outlined"
                fullWidth
                label="Paste contents of the Excel file here."
                name="import_text"
                type="text"
                disabled={this.state.isSaving}
                value={this.state.import_text}
                onChange={(event) => this.handleChange(event, "import_text")}
              />
            </Col>
          </Row>
        </Form>
      </Paper>
      {this.state.dataIsParsed === true && (
      <div className="dense-table" style={{padding: '0px 270px'}}>
        <MUIDataTable
          data={this.getParsedArray(this.state.parsedData)}
          columns={this.getTableColumns()}
          title={"Import Preview"}
          options={{
            filter: true,
            filterType: "dropdown",
            responsive: "vertical",
            tableBodyMaxHeight: " ",
            selectableRows: 'none',
            download:false,
            print:false,
            pagination:false,
            tableBodyMaxHeight: "500px"
          }} />
        <center style={{padding: '20px'}}>
          <Button
            variant="danger"
            disabled={this.state.isSaving}
            onClick={(event) => this.importSubmission(event)}
          >
            Import Bookeeping
          </Button>
        </center>
      </div>)
      }
      <br/>
    </>);
  }

  handleChange = (event, fieldName) => {
    this.setState({ [fieldName]: event.target.value });
  };

  setParseError() {
    this.setState({
      isSaving: false,
      parseError: true
    });
    setTimeout(() => {
      this.setState({parseError: false})
    }, 5000);
  }

  dollarStringToNum(dollarString) {
    if (dollarString.trim() === "$-") {
      return 0;
    }
    return Number(dollarString.replace("$", ""));
  }

  parseBookkeeping = (event) => {

    this.setState({ isSaving: true });

    let rows = this.state.import_text.split("\n");
    const headerIdx = rows.findIndex((e) => {
      return e.startsWith("ID");
    });
    if (headerIdx === -1) {
      this.setParseError();
      return;
    }
    const header = rows[headerIdx].split("\t");

    // trim leading headers and trailing blank rows
    const dataEndIdx = rows.findIndex((e) => {
      return e.startsWith("\t\t");
    });
    // header row plus 2 is where data starts, MIGHT BE a bad dependency
    rows = rows.slice(headerIdx + 2, dataEndIdx);

    // change headTitles content as needed depending on spreadsheet format
    const headTitles = [
      "ID",
      "Regular",
      "Bonus",
      "Total",
      "S/A",
      "Donations",
      "Chgd Stdnt",
      "Bal CryOvr",
      "Student"
    ];
    let headTitleIndices = [];
    for (let headTitle of headTitles) {
      headTitleIndices.push(header.findIndex((e) => e.includes(headTitle)));
    }

    // if we missed some of headTitles in the pasted text, can't move on
    if (headTitles.length !== headTitleIndices.length) {
      this.setParseError();
      return;
    }
    // headTitleIndices now has column indices of the fields we care about

    // used in reduce to turn array into obj with these as keys
    // critical to maintain same order as headTitles
    const columnTemplate = [
      "lcf_id",
      "daily_earned",
      "bonus_earned",
      "gross_earned",
      "amount",  // to_savings
      "pif_paid",
      "debt_paid",
      "debt_remaining",
      "paid_to_student",
    ];
    try {
      /* each mapped element starts as a full, raw row
         and gets turned into an object with columnTemplate vals as keys
       */
      rows = rows.map((e) => {
        let cols = [];
        const rowElements = e.split("\t");
        for (let headTitleIdx of headTitleIndices) {
          cols.push(this.dollarStringToNum(rowElements[headTitleIdx]));
        }
        return cols.reduce((a, v, i) => (
          {...a, [columnTemplate[i]]:v }), {}
        );
      });
    } catch (error) {
      this.setParseError();
      return;
    }
    // if (!this.validateRows(rows)) {
    //   this.setParseError();
    //   return;
    // }  // causes non-iterable error

    this.setState({
      isSaving: false,
      dataIsParsed: true,
      parsedData: rows
    });
  }
  
  importSubmission(event) {
    if (!this.state.pay_day_date) {
      this.setState({ formError: true });
      setTimeout(() => {
        this.setState({formError: false})
      }, 5000);
      return;
    }

    this.setState({ isSaving: true });

    axios.put(`/api/admin/import-bookkeeping/`, {
      pay_day_date: this.state.pay_day_date,
      rows: this.state.parsedData
    })
      .then((res) => {
        this.setState({isSaving: false});
        Swal.fire("Success!", "Bookkeeping was successfully imported.",
          "success");
        this.props.history.push('/home');
      })
      .catch((error) => {
        console.log("Error contacting the server", error.response);
        this.setState({
          apiError: true,
          isSaving: false,
          errorMsg: error.response.statusText
        });
        setTimeout(() => {
          this.setState({apiError: false})
        }, 5000);
      });
  }

  getTableColumns() {
    const nonBorderOptions = {
      sort: false,
      setCellProps: () => ({
        style: { textAlign: 'right' }
      }),
      setCellHeaderProps: () => ({
        style: { textAlign: 'right' }
      })
    };
    return [
      {
        name: "LCF ID", options: {
          sort: false,
          setCellProps: () => ({
            style: { paddingLeft: '18px' }
          }),
          setCellHeaderProps: () => ({
            style: { paddingLeft: '18px' }
          })
        }
      },
      {
        name: "Regular", options: nonBorderOptions
      },
      {
        name: "GPA Bonus", options: nonBorderOptions
      },
      {
        name: "Total", options: nonBorderOptions
      },
      {
        name: "$ to S/A", options: nonBorderOptions
      },
      {
        name: "PIF Auth Donations", options: nonBorderOptions
      },
      {
        name: "Chgd Stdnt", options: nonBorderOptions
      },
      {
        name: "Bal CryOvr", options: nonBorderOptions
      },
      {
        name: "$ to Student", options: {
          sort: false,
          setCellProps: () => ({
            style: {
              textAlign: 'right',
              paddingRight: '18px'
            }
          }),
          setCellHeaderProps: () => ({
            style: {
              textAlign: 'right',
              paddingRight: '18px'
            }
          })
        }
      },
    ];
  }

  getParsedArray(parsedObjectArr) {
    return parsedObjectArr.map((e) => [
      e.lcf_id,
      "$" + e.daily_earned.toFixed(2),
      "$" + e.bonus_earned.toFixed(2),
      "$" + e.gross_earned.toFixed(2),
      "$" + e.amount.toFixed(2),
      "$" + e.pif_paid.toFixed(2),
      "$" + e.debt_paid.toFixed(2),
      "$" + e.debt_remaining.toFixed(2),
      "$" + e.paid_to_student.toFixed(2),
    ]);
  }

  validateRows(rows) {
    for (const row of rows) {
      for (const col of row) {
        if (isNaN(col)) {  // check for non-numericals after parse
          return false;
        }
      }
    }
    return true;
  }

}

const mapStateToProps = (state) => ({

});

export default withRouter(connect(mapStateToProps)(ImportBookkeeping));
